import { render, staticRenderFns } from "./downloadlabelpdfs.vue?vue&type=template&id=369ec96c&"
import script from "./downloadlabelpdfs.vue?vue&type=script&lang=js&"
export * from "./downloadlabelpdfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports